import React from 'react'
import { Paper} from '@mui/material'
import social from '../constants/social.json'

function FastContact() {
  return (
    <Paper id="fast-contact"
      sx={{ 
        p: 1,
        position: "fixed",
        top: "calc(50% - 4rem)",
        zIndex: "20",
        display: {xs: 'none', md: 'block'},
      }}
    >
      { social.map((sm,i) => i===0 ? '':
        <a href={sm.href} target="_blank" key={sm.title}>
          <div title={sm.title}>
            <i className={`fas fa-${sm.icon}`}></i>
          </div>
        </a>
      )}
    </Paper>
  )
}

export default FastContact